import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { changeStatus, copyProperty, deleteProp } from 'redux/propsSlice';
import { checkPermission } from 'utils/checkPermission';
import ButtonActive from 'utils/buttons/ButtonActive';
import ButtonDelete from 'utils/buttons/ButtonDelete';
import ButtonEdit from 'utils/buttons/ButtonEdit';
import ButtonFinish from 'utils/buttons/ButtonFinish';
import ButtonPause from 'utils/buttons/ButtonPause';
import ActiveModal from '../../../modals/ActiveModal';
import DeleteModal from '../../../modals/DeleteModal';
import FinishModal from '../../../modals/FinishModal';
import PauseModal from '../../../modals/PauseModal';
import ButtonView from 'utils/buttons/ButtonView';
import PropTypes from 'prop-types';
import { Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import ButtonShareProperty from 'utils/buttons/ButtonShareProperty';
import ShareModal from '../../../modals/ShareModal';
import ButtonCopyProperty from 'utils/buttons/ButtonCopyProperty';
import SendModal from '../../../modals/SendModal';
import { TitleGenerator } from 'utils/TitleGenerator';
import ButtonShareSocial from 'utils/buttons/ButtonShareSocial';
import ButtonPreview from 'utils/buttons/ButtonPreview';

export const PropActions = ({
  prop,
  userLogged,
  setCheckChanges,
  onlyView
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  //Modales
  const [deleteModal, setDeleteModal] = useState(false);
  const [pauseModal, setPauseModal] = useState(false);
  const [finishModal, setFinishModal] = useState(false);
  const [activeModal, setActiveModal] = useState(false);
  const [shareModal, setShareModal] = useState(false);
  const [sendModal, setSendModal] = useState(false);
  const copyLoadingById = useSelector(state => state.props.copyLoadingById);
  const isCopying = !!copyLoadingById[prop._id];

  const handleStatus = async data => {
    let status = data.status;
    let id = data.id;
    if (status === 'deleted') {
      await dispatch(deleteProp(id));
    } else {
      await dispatch(changeStatus(id, status));
    }

    setCheckChanges(true);
  };

  const handleCopyButton = propId => {
    const response = dispatch(copyProperty(propId));

    response.then(res => {
      res !== 400 && navigate(`/propiedades/editar/${res}`);
    });
  };

  return (
    <>
      <span className="d-flex gap-2">
        {!onlyView && (
          <ButtonEdit
            data={prop._id}
            funcion={id => navigate(`/propiedades/editar/${id}`)}
            key={`edit-${prop._id}`}
            disabled={
              !(
                prop.status !== 'finished' &&
                checkPermission(
                  'Edit properties',
                  userLogged,
                  prop.branch_office
                )
              )
            }
          />
        )}

        {/* modal sendModald button */}
        <ButtonShareSocial
          disabled={!(prop.status === 'published')}
          className="w-100"
          funcion={() => setSendModal(true)}
          data={prop}
          justify="start"
        />

        <ButtonView
          key={`view-${prop._id}`}
          link={`${process.env.REACT_APP_CLIENT_DETAIL}${
            prop._id
          }/${TitleGenerator(prop.title)}`}
          disabled={!(prop.status === 'published')}
        />

        {!onlyView && (
          <Dropdown className="font-sans-serif btn-reveal-trigger">
            <Dropdown.Toggle
              variant="link"
              className="text-600 btn-reveal p-0 px-1 m-0 fs-1"
            >
              <FontAwesomeIcon icon="ellipsis-v" />
            </Dropdown.Toggle>

            <Dropdown.Menu className="bg-white border p-1">
              <Dropdown.Item className="p-1">
                <ButtonEdit
                  data={prop._id}
                  funcion={id => navigate(`/propiedades/editar/${id}`)}
                  key={`edit-${prop._id}`}
                  disabled={
                    !(
                      prop.status !== 'finished' &&
                      checkPermission(
                        'Edit properties',
                        userLogged,
                        prop.branch_office
                      )
                    )
                  }
                  text="Editar"
                  className="w-100"
                  justify="start"
                />
              </Dropdown.Item>

              <Dropdown.Item
                to={`${process.env.REACT_APP_CLIENT_DETAIL}${
                  prop._id
                }/${TitleGenerator(prop.title)}`}
                target="_blank"
                as={Link}
                className="p-1"
              >
                <ButtonView
                  key={`view-${prop._id}`}
                  disabled={!(prop.status === 'published')}
                  text="Ver"
                  className="w-100"
                  justify="start"
                />
              </Dropdown.Item>

              {['pending', 'paused'].includes(prop.status) ? (
                <Dropdown.Item
                  to={`${process.env.REACT_APP_CLIENT}/vista-previa/propiedad/${
                    prop._id
                  }/${TitleGenerator(prop.title)}`}
                  target="_blank"
                  as={Link}
                  className="p-1"
                >
                  <ButtonPreview
                    key={`view-${prop._id}`}
                    text="Vista previa"
                    className="w-100"
                    justify="start"
                  />
                </Dropdown.Item>
              ) : (
                <Dropdown.Item className="p-1">
                  <ButtonPreview
                    key={`view-${prop._id}`}
                    disabled={true}
                    text="Vista previa"
                    className="w-100"
                    justify="start"
                  />
                </Dropdown.Item>
              )}

              <Dropdown.Item className="p-1" onClick={e => e.stopPropagation()}>
                <ButtonCopyProperty
                  key={`view-${prop._id}`}
                  text={isCopying ? 'Copiando...' : 'Copiar ficha'}
                  disabled={isCopying}
                  loading={isCopying}
                  className="w-100"
                  justify="start"
                  funcion={handleCopyButton}
                  data={prop._id}
                />
              </Dropdown.Item>

              <Dropdown.Item className="p-1">
                <ButtonShareProperty
                  className="w-100"
                  funcion={() => setShareModal(true)}
                  data={prop}
                  text="Honorarios"
                  justify="start"
                  disabled={
                    !checkPermission(
                      'Edit properties',
                      userLogged,
                      prop.branch_office
                    )
                  }
                />
              </Dropdown.Item>

              <Dropdown.Item className="p-1">
                <ButtonFinish
                  data={prop}
                  funcion={() => setFinishModal(true)}
                  key={`finish-${prop._id}`}
                  text="Finalizar"
                  justify="start"
                  disabled={
                    !(
                      (prop.status === 'published' ||
                        prop.status === 'paused') &&
                      checkPermission(
                        'Edit properties',
                        userLogged,
                        prop.branch_office
                      )
                    )
                  }
                  className="w-100"
                />
              </Dropdown.Item>

              {prop.status === 'published' &&
                checkPermission(
                  'Edit properties',
                  userLogged,
                  prop.branch_office
                ) && (
                  <Dropdown.Item className="p-1">
                    <ButtonPause
                      data={prop}
                      funcion={() => setPauseModal(true)}
                      key={`pause-${prop._id}`}
                      text="Pausar"
                      className="w-100"
                      justify="start"
                    />
                  </Dropdown.Item>
                )}

              {prop.status === 'paused' &&
                checkPermission(
                  'Edit properties',
                  userLogged,
                  prop.branch_office
                ) && (
                  <Dropdown.Item className="p-1">
                    <ButtonActive
                      data={prop}
                      funcion={() => setActiveModal(true)}
                      key={`active-${prop._id}`}
                      text="Activar"
                      className="w-100"
                      justify="start"
                    />
                  </Dropdown.Item>
                )}

              {prop.status === 'pending' &&
                checkPermission(
                  'Edit properties',
                  userLogged,
                  prop.branch_office
                ) && (
                  <Dropdown.Item className="p-1">
                    <ButtonActive
                      data={prop}
                      funcion={() => setActiveModal(true)}
                      key={`active-${prop._id}`}
                      disabled={true}
                      text="Activar"
                      className="w-100"
                      justify="start"
                    />
                  </Dropdown.Item>
                )}

              <Dropdown.Item className="p-1">
                <ButtonDelete
                  className="w-100"
                  data={prop}
                  funcion={() => setDeleteModal(true)}
                  key={`delete-${prop._id}`}
                  text="Eliminar"
                  justify="start"
                  disabled={
                    !(
                      prop.status !== 'finished' &&
                      checkPermission(
                        'Delete properties',
                        userLogged,
                        prop.branch_office
                      )
                    )
                  }
                />
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        )}
      </span>

      {!onlyView && (
        <>
          {deleteModal && (
            <DeleteModal
              setShow={setDeleteModal}
              property={prop}
              handleStatus={handleStatus}
            />
          )}

          {pauseModal && (
            <PauseModal
              setShow={setPauseModal}
              property={prop}
              handleStatus={handleStatus}
            />
          )}

          {finishModal && (
            <FinishModal
              setShow={setFinishModal}
              property={prop}
              handleStatus={handleStatus}
            />
          )}

          {activeModal && (
            <ActiveModal
              setShow={setActiveModal}
              property={prop}
              handleStatus={handleStatus}
            />
          )}

          {shareModal && (
            <ShareModal
              setShow={setShareModal}
              property={prop}
              setCheckChanges={setCheckChanges}
            />
          )}
          {sendModal && (
            <SendModal
              setShow={setSendModal}
              property={prop}
              setCheckChanges={setCheckChanges}
              type="property"
            />
          )}
        </>
      )}
    </>
  );
};

PropActions.propTypes = {
  prop: PropTypes.object.isRequired,
  userLogged: PropTypes.object.isRequired,
  setCheckChanges: PropTypes.func.isRequired,
  onlyView: PropTypes.bool
};
